<template>
    <v-dialog v-model="dialog" max-width="700px" @click:outside="hide" scrollable>
        <v-card tile>
            <v-card-title>
                <v-icon color="black" left size="40">
                    {{ editMode ? 'mdi-account-outline' : 'mdi-account-plus-outline' }}
                </v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Editar' : 'Agregar' }} Usuario de Rendiciones
                    <div class="title-subtext">
                        Completa los siguientes datos
                    </div>
                </div>
                <v-spacer />
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <kimsa-select label="Cliente" placeholder="Selecciona un cliente" bolder-label :items="clients"
                            outlined solo flat dense item-text="name" item-value="id" force-value :value="client"
                            @change="client = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Nombre" placeholder="Ingresar Nombre" bolder-label outlined solo flat
                            dense force-value :value="name" @change="name = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Email" placeholder="Email" bolder-label outlined dense force-value
                            inputMode="email" :value="email" @change="email = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="DNI/RUT/PASAPORTE" placeholder="Ingresar DNI/RUT/PASAPORTE" bolder-label outlined solo flat
                            dense force-value :value="dni"
                            @change="dni = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Cargo" placeholder="Cargo" bolder-label outlined dense force-value
                            :value="jobTitle" @change="jobTitle = $event" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-textarea-field label="Observaciones" placeholder="Observaciones" bolder-label outlined
                            dense force-value :value="notes" @change="notes = $event" />
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn @click="editMode ? editUser() : saveUser()" tile color="primary" depressed
                            :disabled="!valid || loadingDelete" :loading="loading">
                            {{ editMode ? 'GUARDAR' : 'AGREGAR' }}
                        </v-btn>
                    </v-col>
                    <div class="explain-text">
                        Opción de creación de usuarios ( personas que realizaran rendiciones), uso interno solo para administradores AMB. (USO INTERNO NO LO VEN LOS CLIENTES)
                    </div>
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>

import { mapMutations, mapState } from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import Axios from "@/utils/Axios";
import KimsaTextareaField from '../common/inputs/KimsaTextareaField.vue';
import KimsaSelect from '../common/inputs/KimsaSelect.vue';

export default {
    name: "CreateExpenseReportUserDialog",
    components: { KimsaTextField, KimsaTextareaField, KimsaSelect },
    data() {
        return {
            dialog: false,
            loading: false,
            loadingDelete: false,
            editMode: false,
            user: null,
            clients: [],
            client: null,
            name: '',
            email: '',
            dni: '',
            notes: '',
            jobTitle: '',
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        valid(vm = this) {
            return !!vm.client && !!vm.name && vm.validEmail(vm.email) && !!vm.dni
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show() {
            const vm = this
            await vm.loadClients()
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.client = null
            vm.name = ''
            vm.email = ''
            vm.dni = ''
            vm.notes = ''
            vm.jobTitle = ''
        },
        async loadClients() {
            const vm = this
            await Axios.get(`clients`).then(res => {
                // console.log('res loadClients', res)
                vm.clients = res.data.result.clients
            }).catch(er => {
                console.log('error loadClients', er)
            })
        },
        async loadUser(id) {
            const vm = this
            await Axios.get(`expense-reports/users/${id}`).then(res => {
                // console.log('res loadUser', res)
                vm.user = res.data.result.user
                vm.editMode = true
                vm.client = vm.user.clients?.[0].id || null
                vm.name = vm.user.name
                vm.email = vm.user.email
                vm.dni = vm.user.dni
                vm.notes = vm.user.notes
                vm.jobTitle = vm.user.job_title
                vm.show()
            }).catch(er => {
                console.log('error loadUser', er)
            })
        },
        async saveUser() {
            const vm = this
            vm.loading = true
            // console.log('saveUser', vm)

            let payload = {
                client_id: vm.client,
                name: vm.name,
                email: vm.email,
                dni: vm.dni,
                notes: vm.notes,
                job_title: vm.jobTitle
            }

            // console.log('payload', payload)

            await Axios.post('expense-reports/users/new', payload).then(res => {
                // console.log('res saveUser',res)
                vm.toast('Usuario creado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error saveUser', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        async editUser() {
            const vm = this
            vm.loading = true

            // console.log('editUser', vm)

            let payload = {
                client_id: vm.client,
                name: vm.name,
                email: vm.email,
                dni: vm.dni,
                notes: vm.notes,
                job_title: vm.jobTitle
            }

            // console.log('payload', payload)

            await Axios.patch(`expense-reports/users/${vm.user.id}/edit`, payload).then(res => {
                // console.log('res editUser',res)
                vm.toast('Usuario editado')
                vm.$emit('success')
            }).catch(error => {
                console.log('error editUser', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        validEmail(email) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(email) || false
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.label {
    font-size: 15px;
    color: #333333;
}
</style>